<template>
  <div>
    <van-nav-bar
      class="backBox"
      title=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <BarScan ref="qrcode" @ok="getResult" @err="geterror"></BarScan>
  </div>
</template>
<script>
import BarScan from '../scanQRCode/qrcode.vue'
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Dialog, Toast } from 'vant'
export default {
  components: { BarScan },
  data () {
    return {
      resultUrl: '',
      imgUrl: ''
    }
  },
  created () {

  },
  mounted () {
    this.resultUrl = ''
    this.imgUrl = ''
    // this.getSignInUrl()
    // this.getSignOutUrl()
  },
  computed: {

  },
  methods: {
    // 获取签到URL 本地测试所需
    getSignInUrl () {
      const para = {
        room_id: 45
      }
      api
        .axiosRequest(api.urlList.getSignInUrl, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 获取签退URL 本地测试所需
    getSignOutUrl () {
      const para = {
        room_id: 45
      }
      api
        .axiosRequest(api.urlList.getSignOutUrl, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {

          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 整理URL以备签到签退
    getWhoToSign (imgUrl) {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      //
      let roomId, bookId, type, t
      const modeType = this.$router.mode
      if (modeType === 'hash') {
        // 获取指定参数
        roomId = utils.GetQueryString('room_id', imgUrl)
        bookId = utils.GetQueryString('book_id', imgUrl)
        type = utils.GetQueryString('type', imgUrl)
        t = utils.GetQueryString('t', imgUrl)
      } else {
        // 使用 URL 对象解析 URL
        var url = new URL(imgUrl)
        var searchParams = url.searchParams
        roomId = searchParams.get('room_id')
        bookId = searchParams.get('book_id')
        type = searchParams.get('type')
        t = searchParams.get('t')
      }
      // url 'https://qfgl.zjhu.edu.cn/h5/#/sign_in_out?room_id=45&book_id=-1&type=in&t=1697001495915'

      const typeName = type === 'in' ? '签到' : '签退'
      // 判断t和现在时间 大于5分钟不可签到签退

      const timeOutFive = utils.getFiveTimeOut(t)

      if (timeOutFive) {
        if (this.imgUrl !== imgUrl) {
          // 跳转到签到签退页面

          Toast.clear()
          this.$router.push({
            path: '/sign_in_out',
            query: {
              room_id: roomId,
              book_id: bookId,
              type: type,
              t: t
            }
          })
        } else {
          Toast.clear()
          Dialog.alert({
            title: '提示',
            message: '您已' + typeName + '成功，无需再次' + typeName + '!'
          }).then(() => {
            this.onClickLeft()
          })
        }
      } else {
        Toast.clear()

        Dialog.confirm({
          title: '提示',
          message: '二维码已超时!',
          confirmButtonText: '继续扫码',
          cancelButtonText: '返回主页'
        }).then(() => {
          // on confirm
        }).catch(() => {
          // on cancel
          this.onClickLeft()
        })
      }

      // return false
    },
    // 获取扫码结果
    getResult (resultUrl) {
      console.log('获取到结果URL', resultUrl)

      // 测试  签到 URL
      // resultUrl = 'https://qfgl.zjhu.edu.cn/h5/#/sign_in_out?room_id=45&book_id=-1&type=in&t=1697001495915'
      // 签退URL
      // resultUrl = 'https://qfgl.zjhu.edu.cn/h5/#/sign_in_out?room_id=45&book_id=-1&type=out&t=1696990211018'

      this.getWhoToSign(resultUrl)
    },
    geterror (e) {
      Toast.fail(e)
      setTimeout(() => {
        this.$router.replace('/order')
      }, 300)
    },
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
</style>
